/**
 * Extrae TODOS los placeholders ${...} del XML ya reconstruido.
 */
export function extraerExpresiones(xml) {
  const resultados = []
  const n = xml.length
  let i = 0

  while (i < n) {
    const start = xml.indexOf('${', i)
    if (start === -1) break

    let j = start + 2
    let depth = 1

    while (j < n && depth > 0) {
      const c = xml[j]
      if (c === '{') depth++
      else if (c === '}') depth--
      j++
    }

    if (depth === 0) {
      const tag = xml.slice(start, j)
      const contenido = tag.replace(/^\$\{|\}$/g, '')
      resultados.push({
        tag, // Ej: ${nombreN1}
        contenido, // Ej: nombreN1
        index: start,
      })
      i = j
      continue
    }

    // Si no cerró correctamente, saltar el '${' para evitar loop infinito
    i = start + 2
  }
  return resultados
}
